import moment from 'moment'

export const getYear = () => {
  let thisYear = parseInt(moment().utc().format().substring(0, 4))
  var i = 0
  var year = [{ Text: 'Select Year', Value: '' },
    { Text: thisYear - 1, Value: thisYear - 1 },
    { Text: thisYear, Value: thisYear }]
  while (i < 4) {
    thisYear += 1
    year.push({ Text: thisYear, Value: thisYear })
    i++
  }
  return year
}

export const getMonths = [
  { Text: 'Select month', Value: '' },
  { Text: 'January', Value: 1 },
  { Text: 'February', Value: 2 },
  { Text: 'March', Value: 3 },
  { Text: 'April', Value: 4 },
  { Text: 'May', Value: 5 },
  { Text: 'June', Value: 6 },
  { Text: 'July', Value: 7 },
  { Text: 'August', Value: 8 },
  { Text: 'September', Value: 9 },
  { Text: 'October', Value: 10 },
  { Text: 'November', Value: 11 },
  { Text: 'December', Value: 12 }
]
